import _ from "lodash";

export function getStringOrNull(value) {
  if (!value) {
    return null
  }

  if (typeof value !== 'string') {
    return null
  }

  if (value.length === 0) {
    return null
  }

  return _.trim(value)
}